module.exports = __webpack_public_path__ + "static/img/far3_active.6083bb4c.png";